export default __webpack_public_path__ + "static/media/bt_logo_icon.364d2bb2.png";